export const SOURCE_TYPES = {
  CREDIT: 'credit',
  CASH: 'cash',
};

export const SOURCE_LABELS = {
  CREDIT: 'Credit Processing',
  CASH: 'Cash Processing',
};

export const TABLE_TITLES = {
  CREDIT: 'Seedlive Credit Processing',
  CASH: 'Seedlive Cash Processing',
};

export const FIELD_KEYS = {
  FEED: 'rows_feed',
  STAGING: 'rows_staging',
  FAILED: 'rows_failed',
  SUCCESS: 'rows_success',
  UNMAPPED: 'rows_unmapped',
  INSERTED: 'rows_inserted',
  UPDATED: 'rows_updated',
  DELETED: 'rows_deleted',
  REINSTATED: 'rows_reinstated',
  ERROR_TEXT: 'error_text',
  ERROR_DETAIL: 'error_detail',
};

export const SOURCE_OPTIONS = [
  { value: SOURCE_TYPES.CREDIT, label: SOURCE_LABELS.CREDIT, testId: 'credit-option' },
  { value: SOURCE_TYPES.CASH, label: SOURCE_LABELS.CASH, testId: 'cash-option' },
];

const FIELD_LABELS = {
  FEED: 'Feed Rows',
  STAGING: 'Staging Rows',
  FAILED: 'Failed Rows',
  SUCCESS: 'Successful Rows',
  UNMAPPED: 'Unmapped Rows',
  INSERTED: 'Inserted Rows',
  UPDATED: 'Updated Rows',
  DELETED: 'Deleted Rows',
  REINSTATED: 'Reinstated Rows',
  ERROR_TEXT: 'Error Message',
  ERROR_DETAIL: 'Error Details',
};

const createFieldsArray = (prefix) => [
  { label: FIELD_LABELS.FEED, field: `seedlive_${prefix}_rows_feed` },
  { label: FIELD_LABELS.STAGING, field: `seedlive_${prefix}_rows_staging` },
  { label: FIELD_LABELS.FAILED, field: `seedlive_${prefix}_rows_failed` },
  { label: FIELD_LABELS.SUCCESS, field: `seedlive_${prefix}_rows_success` },
  { label: FIELD_LABELS.UNMAPPED, field: `seedlive_${prefix}_rows_unmapped` },
  { label: FIELD_LABELS.INSERTED, field: `seedlive_${prefix}_rows_inserted` },
  { label: FIELD_LABELS.UPDATED, field: `seedlive_${prefix}_rows_updated` },
  { label: FIELD_LABELS.DELETED, field: `seedlive_${prefix}_rows_deleted` },
  { label: FIELD_LABELS.REINSTATED, field: `seedlive_${prefix}_rows_reinstated` },
  { label: FIELD_LABELS.ERROR_TEXT, field: `seedlive_${prefix}_error_text`, isError: true },
  { label: FIELD_LABELS.ERROR_DETAIL, field: `seedlive_${prefix}_error_detail`, isError: true },
];

export const CREDIT_FIELDS = createFieldsArray(SOURCE_TYPES.CREDIT);
export const CASH_FIELDS = createFieldsArray(SOURCE_TYPES.CASH);

export const CELL_WIDTH = 150;

export const TEXT_NODE_STYLES = {
  display: 'inline-block',
  width: '100%',
  maxWidth: CELL_WIDTH - 16, // Account for padding
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: '0.70rem',
  fontWeight: 500,
  lineHeight: 1.2,
  m: 0,
  p: 0,
  verticalAlign: 'middle',
  color: 'inherit',
};
